export default "__VITE_ASSET__BOHK6qTG__"